module.exports = __webpack_public_path__ + "static/media/sgs_en.82f1a55e.8dcfe602.jpg";